<template>
  <div class="col mx-auto text-center mt-5">
    <div class="spinner-border" role="status">
      <span class="sr-only">Chargement...</span>
    </div>
  </div>
</template>
<script>
export default {};
</script>
